import type { ComponentType } from 'react'
import App_User_Auth_ShowLogin from '../../../react/src/App/User/Page/Auth/UserLoginPage'
import FreeTool_BusinessNameGenerator_StepStart from '../../../react/src/FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepStartPage'
import FreeTool_BusinessNameGenerator_StepResults from '../../../react/src/FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepResultsPage'
import FreeTool_BusinessNameGenerator_StepResultPreview from '../../../react/src/FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepResultPreviewPage'
import FreeTool_BusinessNameGenerator_StepRegister from '../../../react/src/FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepRegisterPage'
import FreeTool_BusinessNameGenerator_StepSuccess from '../../../react/src/FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepSuccessPage'
import Dev_KitchenSinkPage from '../../../react/src/Dev/Page/KitchenSinkPage'

const ReactPages: Record<string, ComponentType<any>> = {
    'App/User/Page/Auth/UserLoginPage': App_User_Auth_ShowLogin,
    'FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepStartPage': FreeTool_BusinessNameGenerator_StepStart,
    'FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepResultsPage': FreeTool_BusinessNameGenerator_StepResults,
    'FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepResultPreviewPage': FreeTool_BusinessNameGenerator_StepResultPreview,
    'FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepRegisterPage': FreeTool_BusinessNameGenerator_StepRegister,
    'FreeTool/BusinessNameGenerator/Page/BusinessNameGeneratorStepSuccessPage': FreeTool_BusinessNameGenerator_StepSuccess,
    'Dev/Page/KitchenSinkPage': Dev_KitchenSinkPage,
}

export function getReactPage(pageName: string): ComponentType<any> {
    const page = ReactPages[pageName]

    if (! page) {
        throw new Error(`React page ${pageName} cannot be loaded.`)
    }

    return page
}
